import CreateEventDroppable, { CreateEventDroppableProps } from './CreateEventDroppable';
import EventDropHintView from './EventDropHintView';
import { getEventDropState, getTimePanelDropState } from '../selectors/timePanelDndStoreSelectors';
import { observer } from 'mobx-react-lite';
import { DraggableItemTypes } from 'owa-dnd';
import { ConditionalDropHint } from 'owa-drophint-views';
import * as React from 'react';

const styles = require('./TimePanelAgendaDropHintView.scss');

type TimePanelAgendaDropHintViewProps = Pick<CreateEventDroppableProps, 'selectedDate'>;

export default observer(function TimePanelAgendaDropHintView(
    props: TimePanelAgendaDropHintViewProps
) {
    const { selectedDate } = props;
    const timePanelDropState = getTimePanelDropState();
    const eventDropState = getEventDropState();

    return (
        <ConditionalDropHint
            dragItemType={DraggableItemTypes.MailListRow}
            dropViewState={timePanelDropState}
            dropHintView={
                <CreateEventDroppable
                    classNames={styles.timePanelAgendaDropHintView}
                    dropViewState={eventDropState}
                    dropTarget={'AgendaViewDropHint'}
                    selectedDate={selectedDate}>
                    <EventDropHintView dropViewState={eventDropState} />
                </CreateEventDroppable>
            }
        />
    );
});
